<div class="container">
  <div class="content-pane">
    <div class="content">
      <div class="header">Household Count Details</div>
      <div class="seperator"></div>
      <div class="household-group">
        <div class="households-container">
          <div class="household-content">
            <div class="household-title">All Households</div>
            <div class="target-count">Target: {{ allHouseHoldsTarget }} Control: {{ allHouseHoldsControl }}</div>
          </div>
        </div>
        <div class="indent" *ngIf="selectedSubscriberHouseholds.length > 0">
          <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="39" height="73" viewBox="0 0 39 73" fill="none">
            <path
              d="M1.5 1V0.5H0.5V1H1.5ZM38.3536 69.3536C38.5488 69.1583 38.5488 68.8417 38.3536 68.6464L35.1716 65.4645C34.9763 65.2692 34.6597 65.2692 34.4645 65.4645C34.2692 65.6597 34.2692 65.9763 34.4645 66.1716L37.2929 69L34.4645 71.8284C34.2692 72.0237 34.2692 72.3403 34.4645 72.5355C34.6597 72.7308 34.9763 72.7308 35.1716 72.5355L38.3536 69.3536ZM1 1H0.5V65H1H1.5V1H1ZM5 69V69.5H38V69V68.5H5V69ZM1 65H0.5C0.5 67.4853 2.51472 69.5 5 69.5V69V68.5C3.067 68.5 1.5 66.933 1.5 65H1Z"
              fill="#9BA9BD"
            />
          </svg>
          <div class="spectrum-households">
            <div class="households-container">
              <div class="household-content">
                <div class="household-title">Spectrum Households</div>
                <div class="target-count">
                  Target: {{ selectedSubscriberHouseholdsTarget }} Control: {{ selectedSubscriberHouseholdsControl }}
                </div>
              </div>
            </div>
            <div *ngFor="let universe of selectedSubscriberHouseholds" class="indent">
              <svg
                class="arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="39"
                height="73"
                viewBox="0 0 39 73"
                fill="none"
              >
                <path
                  d="M1.5 1V0.5H0.5V1H1.5ZM38.3536 69.3536C38.5488 69.1583 38.5488 68.8417 38.3536 68.6464L35.1716 65.4645C34.9763 65.2692 34.6597 65.2692 34.4645 65.4645C34.2692 65.6597 34.2692 65.9763 34.4645 66.1716L37.2929 69L34.4645 71.8284C34.2692 72.0237 34.2692 72.3403 34.4645 72.5355C34.6597 72.7308 34.9763 72.7308 35.1716 72.5355L38.3536 69.3536ZM1 1H0.5V65H1H1.5V1H1ZM5 69V69.5H38V69V68.5H5V69ZM1 65H0.5C0.5 67.4853 2.51472 69.5 5 69.5V69V68.5C3.067 68.5 1.5 66.933 1.5 65H1Z"
                  fill="#9BA9BD"
                />
              </svg>
              <div class="households-container">
                <div class="household-content">
                  <div class="household-title">{{ universe.name }}</div>
                  <div class="target-count">
                    Target:
                    {{ campaignBuilderService.getProfileTargetTotalUniverseCount(priority, universe.name) }} Control:
                    {{ campaignBuilderService.getProfileControlTotalUniverseCount(priority, universe.name) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngFor="let universe of selectedNonSubscriberHouseholds" class="indent">
          <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="39" height="73" viewBox="0 0 39 73" fill="none">
            <path
              d="M1.5 1V0.5H0.5V1H1.5ZM38.3536 69.3536C38.5488 69.1583 38.5488 68.8417 38.3536 68.6464L35.1716 65.4645C34.9763 65.2692 34.6597 65.2692 34.4645 65.4645C34.2692 65.6597 34.2692 65.9763 34.4645 66.1716L37.2929 69L34.4645 71.8284C34.2692 72.0237 34.2692 72.3403 34.4645 72.5355C34.6597 72.7308 34.9763 72.7308 35.1716 72.5355L38.3536 69.3536ZM1 1H0.5V65H1H1.5V1H1ZM5 69V69.5H38V69V68.5H5V69ZM1 65H0.5C0.5 67.4853 2.51472 69.5 5 69.5V69V68.5C3.067 68.5 1.5 66.933 1.5 65H1Z"
              fill="#9BA9BD"
            />
          </svg>
          <div class="households-container">
            <div class="household-content">
              <div class="household-title">{{ universe.name }}</div>
              <div class="target-count">
                Target:
                {{ campaignBuilderService.getProfileTargetTotalUniverseCount(priority, universe.name) }} Control:
                {{ campaignBuilderService.getProfileControlTotalUniverseCount(priority, universe.name) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="seperator"></div>
      <button class="close-button" mat-raised-button color="primary" type="button" (click)="close()">Close</button>
    </div>
    <mat-icon fontIcon="close" class="icon" (click)="close()">close</mat-icon>
  </div>
</div>
